<template>
	<ul class="menu-item-parent" :class="{}">
		<!-- self -->
		<li :class="'menu-item ' + (nodeExpandable && nodeExpanded ? 'expanded' : '') + ' ' + (childrenNodeSrc ? 'child-active': '')" @click="toggleNodeClick($event)" @mouseover="toggleNodeMouseover($event)" @mouseleave="toggleNodeMouseleave($event)">
			<span v-if="nodeExpandable" class="icon-container">
				<fa-icon v-if="nodeExpandable" :icon="nodeExpanded ? 'angle-down' : 'angle-right'" size="xs" />
			</span>
			<template v-if="!nodeExpandable">
				<router-link :to="nodeSrc" :disabled="nodeExpandable">
					<span v-if="featureSet.mainMenu.menuItemDecoration" class="menu-item-decoration" :class="{'menu-item-expandable': nodeExpandable}">
						<fa-icon icon="circle" :to="nodeSrc"/>
					</span>
					{{ node.title[language] }}
				</router-link>
			</template>
			<template v-if="nodeExpandable">
				<span v-if="featureSet.mainMenu.menuItemDecoration" class="menu-item-decoration" :class="{'menu-item-expandable': nodeExpandable}">
					<fa-icon icon="circle" :to="nodeSrc"/>
				</span>
				{{ node.title[language] }}
			</template>
		</li>
		<!-- children -->
		<li v-show="nodeExpanded" class="menu-item-children-container" @mouseover="toggleNodeMouseover($event)" @mouseleave="toggleNodeMouseleave($event)">
			<MenuItem v-for="(newnode, index) in node.childrenArray" :node="newnode" :key="index" @item-clicked="$emit('item-clicked', {id: node.id});"/>
		</li>
		<div class="menu-item-bottom-decoration" v-if="featureSet.mainMenu.menuItemBottomDecoration"></div>
	</ul>
</template>

<script>
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';

export default {
	name: 'MenuItem',
	mixins: [staticDataLoaderMixin, featureSetLoaderMixin],
	props: {
		node: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			nodeExpanded: false,
		};
	},
	created() {
		// register the event listener
		this.$root.$on('node-expanded', this.nodeExpandedListener);
		this.$root.$on('node-clicked', this.nodeClickedListener);
	},
	beforeDestroy() {
		this.$root.$off('node-expanded', this.nodeExpandedListener);
		this.$root.$off('node-clicked', this.nodeClickedListener);
	},
	watch: {
		// eslint-disable-next-line
		$route(to, from) {
			// console.log(from);
			this.nodeExpanded = false;
		},
	},
	computed: {
		nodeExpandable() {
			return (this.node.childrenArray.length > 0 && this.featureSet.mainMenu.expandableItems);
		},
		nodeSrc() {
			return this.getNodeSrc(this.node);
		},
		childrenNodeSrc() {
			const childrenNodeArray = [];
			if (this.nodeExpandable) {
				this.node.childrenArray.forEach((c) => {
					const node = this.getNodeSrc(c);
					childrenNodeArray.push(node);
				});
			}
			return childrenNodeArray.includes(this.$route.fullPath);
		},
		isMobile() {
			const mm = window.matchMedia('(max-width: 900px)');
			return mm.matches;
		},
	},
	methods: {
		toggleNode(e) {
			if (this.nodeExpandable) {
				e.stopPropagation();
				this.nodeExpanded = !this.nodeExpanded;
				this.$root.$emit('node-expanded', { id: this.node.id });

				if (this.nodeExpanded && this.featureSet.mainMenu.openOnExpand) {
					this.$router.push(this.getNodeSrc(this.node.childrenArray[0]));
				}
			} else {
				this.$emit('item-clicked', { id: this.node.id });
				this.$root.$emit('node-clicked', { id: this.node.id });
			}
		},
		toggleNodeClick(e) {
			if (this.featureSet.mainMenu.expandOnHover) {
				if (this.isMobile) {
					this.toggleNode(e);
				}
			} else {
				this.toggleNode(e);
			}
		},
		toggleNodeMouseover() {
			if (this.featureSet.mainMenu.expandOnHover && !this.isMobile && this.nodeExpandable) {
				this.nodeExpanded = true;
			}
		},
		toggleNodeMouseleave() {
			if (this.featureSet.mainMenu.expandOnHover && !this.isMobile && this.nodeExpandable) {
				this.nodeExpanded = false;
			}
		},
		nodeExpandedListener(data) {
			if (data.id !== this.node.id) {
				this.nodeExpanded = false;
			}
		},
		nodeClickedListener(data) {
			const isChild = this.node.childrenArray.find(e => e.id === data.id);
			if ((isChild && !this.featureSet.mainMenu.openOnExpand) || !isChild) {
				this.nodeExpanded = false;
			}
		},
		getNodeSrc(node) {
			if (node.page_id) {
				return `/page/${node.page_id}`;
			} else if (node.category_id) {
				return `/posts/${node.category_id}`;
			} else if (node.url) {
				return node.url;
			}

			return '';
		},
	},
};
</script>

<style src="@/styles/components/MenuItem/MenuItem.less" lang="less" scoped></style>
